/*
 * @Author: GXQ
 * @Date: 2022-01-23 16:34:53
 * @LastEditTime: 2022-01-29 18:29:39
 * @LastEditors: GXQ
 * @Description: U1
 * @FilePath: \u1\src\routers\index.tsx
 */
import React,{lazy} from 'react'

const Index = lazy(() => import('pages/index'))
const Home = lazy(() => import('pages/home'))
const Pledge = lazy(() => import('pages/play/pledge'))
const Matrix = lazy(() => import('pages/play/matrix'))
// const Game = lazy(() => import('pages/play/game'))
const More = lazy(() => import('pages/play/more'))

interface router {
    path: string,
    component: any,
    children?: Array<router>
    exact?: boolean,
    meta: object,
    onEnter: object
}

const routers: Array<router> = [
    {
        path: '/',
        component: Index,
        children: [],
        exact: true,
        meta: {
            title: '引导'
        },
        onEnter: {}
    },
    {
        path: '/home',
        component: Home,
        children: [],
        exact: true,
        meta: {
            title: '首页'
        },
        onEnter: {}
    },
    {
        path: '/matrix',
        component: Matrix,
        children: [],
        exact: true,
        meta: {
            title: '矩阵池'
        },
        onEnter: {}
    },
    {
        path: '/matrix/:inviteCode',
        component: Matrix,
        children: [],
        exact: false,
        meta: {
            title: '矩阵池邀请'
        },
        onEnter: {
            
        }
    },
    {
        path: '/pledge',
        component: Pledge,
        children: [],
        exact: true,
        meta: {
            title: '质押挖矿'
        },
        onEnter: {}
    },
    {
        path: '/more',
        component: More,
        children: [],
        exact: true,
        meta: {
            title: '更多'
        },
        onEnter: {}
    }
]

export default routers
